/* bsb-product-info.js — configurator: color/size/country change handlers,
   ball image swap, size price sync, URL sync, pump add-on.
   All data flows from the #bsb-product-data island and data-* attrs
   set by the swatch / size snippets. No hardcoded option maps. */

(function () {
  'use strict';

  const dataEl = document.getElementById('bsb-product-data');
  if (!dataEl) return;

  let data;
  try {
    data = JSON.parse(dataEl.textContent);
  } catch (err) {
    console.warn('[bsb-pi] Failed to parse product data island:', err);
    return;
  }

  const variants    = data.variants    || [];
  const colorPos    = data.colorPos    != null ? data.colorPos    + 1 : null;
  const sizePos     = data.sizePos     != null ? data.sizePos     + 1 : null;
  const countryPos  = data.countryPos  != null ? data.countryPos  + 1 : null;
  const sportPos    = data.sportPos    != null ? data.sportPos    + 1 : null;
  const planetPos   = data.planetPos   != null ? data.planetPos   + 1 : null;
  const printPos    = data.printPos    != null ? data.printPos    + 1 : null;
  const letterPos   = data.letterPos   != null ? data.letterPos   + 1 : null;
  const lineColorPos = data.lineColorPos != null ? data.lineColorPos + 1 : null;
  const pumpPos = data.pumpPos != null ? data.pumpPos + 1 : null;
  const highVariantMode = !!data.highVariantMode;
  const rootEl = document.querySelector('.bsb-pi');
  const sectionId = rootEl && rootEl.dataset.sectionId;
  const configEl = document.getElementById('bsb-configurator');

  let sizesFieldset  = document.getElementById('bsb-sizes');
  let colorNameEl    = document.getElementById('bsb-color-name');
  let sizeNameEl     = document.getElementById('bsb-size-name');
  let countryNameEl  = document.getElementById('bsb-country-name');
  let sportNameEl    = document.getElementById('bsb-sport-name');
  let planetNameEl   = document.getElementById('bsb-planet-name');
  let printNameEl    = document.getElementById('bsb-print-name');
  let letterNameEl   = document.getElementById('bsb-letter-name');
  let lineColorNameEl = document.getElementById('bsb-line-color-name');
  let pumpNameEl     = document.getElementById('bsb-pump-name');
  let tipEl          = document.getElementById('bsb-size-tooltip');
  let tipTitleEl     = document.getElementById('bsb-size-tip-title');
  let tipBestEl      = document.getElementById('bsb-size-tip-best');
  let pricePanelEl   = document.getElementById('bsb-pi-price');

  function requeryConfiguratorRefs() {
    sizesFieldset   = document.getElementById('bsb-sizes');
    colorNameEl     = document.getElementById('bsb-color-name');
    sizeNameEl      = document.getElementById('bsb-size-name');
    countryNameEl   = document.getElementById('bsb-country-name');
    sportNameEl     = document.getElementById('bsb-sport-name');
    planetNameEl    = document.getElementById('bsb-planet-name');
    printNameEl     = document.getElementById('bsb-print-name');
    letterNameEl    = document.getElementById('bsb-letter-name');
    lineColorNameEl = document.getElementById('bsb-line-color-name');
    pumpNameEl      = document.getElementById('bsb-pump-name');
    tipEl           = document.getElementById('bsb-size-tooltip');
    tipTitleEl      = document.getElementById('bsb-size-tip-title');
    tipBestEl       = document.getElementById('bsb-size-tip-best');
    pricePanelEl    = document.getElementById('bsb-pi-price');
  }

  const BALL_IDS = ['bsb-ball', 'bsb-ball-mobile'];

  function getBallImgs() {
    return BALL_IDS.map((id) => document.getElementById(id)).filter(Boolean);
  }

  const OPTION_POS_BY_INPUT_NAME = {
    'bsb-color':   colorPos,
    'bsb-size':    sizePos,
    'bsb-country': countryPos,
    'bsb-sport':   sportPos,
    'bsb-planet':  planetPos,
    'bsb-print':   printPos,
    'bsb-letter':  letterPos,
    'bsb-line-color': lineColorPos,
    'bsb-pump':    pumpPos,
  };

  function activeExtraInputs() {
    return Array.from(document.querySelectorAll('input[name^="bsb-opt-"]:checked'));
  }

  function extraPosFromInputName(name) {
    const n = parseInt(name.slice('bsb-opt-'.length), 10);
    return Number.isFinite(n) ? n + 1 : null;
  }

  function findVariantForOverride(overridePos, overrideValue) {
    const active = {};
    if (colorPos)   active[colorPos]   = activeColor()   ? activeColor().value   : null;
    if (sizePos)    active[sizePos]    = activeSize()    ? activeSize().value    : null;
    if (countryPos) active[countryPos] = activeCountry() ? activeCountry().value : null;
    if (sportPos)   active[sportPos]   = activeSport()   ? activeSport().value   : null;
    if (planetPos)  active[planetPos]  = activePlanet()  ? activePlanet().value  : null;
    if (printPos)   active[printPos]   = activePrint()   ? activePrint().value   : null;
    if (letterPos)  active[letterPos]  = activeLetter()  ? activeLetter().value  : null;
    if (lineColorPos) active[lineColorPos] = activeLineColor() ? activeLineColor().value : null;
    if (pumpPos)    active[pumpPos]    = activePump()    ? activePump().value    : null;
    activeExtraInputs().forEach((input) => {
      const pos = extraPosFromInputName(input.name);
      if (pos) active[pos] = input.value;
    });
    active[overridePos] = overrideValue;

    return variants.find((v) => Object.keys(active).every((pos) => {
      const val = active[pos];
      return val == null || v['option' + pos] === val;
    })) || null;
  }

  function syncAvailability() {
    if (highVariantMode) return;
    document.querySelectorAll('input[type="radio"][name^="bsb-"]').forEach((input) => {
      const pos = input.name.indexOf('bsb-opt-') === 0
        ? extraPosFromInputName(input.name)
        : OPTION_POS_BY_INPUT_NAME[input.name];
      if (!pos || !input.id) return;
      const variant = findVariantForOverride(pos, input.value);
      const soldOut = !variant || variant.available === false;
      document.querySelectorAll('label[for="' + CSS.escape(input.id) + '"]').forEach((label) => {
        const base = label.classList[0];
        if (base) label.classList.toggle(base + '--unavailable', soldOut);
        label.classList.toggle('bsb-pi__sold-out', soldOut);
        let note = label.querySelector('.bsb-pi__sold-out-note');
        if (soldOut && !note) {
          note = document.createElement('span');
          note.className = 'bsb-pi__sold-out-note visually-hidden';
          note.textContent = ', sold out';
          label.appendChild(note);
        } else if (!soldOut && note) {
          note.remove();
        }
      });
    });
  }

  function applyVariantImage(img, variant) {
    if (!img || !variant) return;
    const newSrc = variant.img900 || variant.img600 || variant.img1200 || variant.img400;
    if (!newSrc) return;
    if (img.getAttribute('src') === newSrc) return;
    img.removeAttribute('srcset');
    img.src = newSrc;
  }

  function syncCarouselSlides() {
    document.querySelectorAll('.bsb-pi__swiper').forEach((swiperEl) => {
      const pos = OPTION_POS_BY_INPUT_NAME[swiperEl.dataset.inputName];
      if (!pos) return;
      swiperEl.querySelectorAll('.bsb-pi__ball-slide').forEach((slide) => {
        const value = slide.getAttribute('data-option-value');
        const img   = slide.querySelector('.bsb-pi__ball-img');
        applyVariantImage(img, findVariantForOverride(pos, value));
      });
    });
  }

  const productTitle = (document.querySelector('.bsb-pi__title') || {}).textContent || '';

  const delDateEl = document.getElementById('bsb-del-date');

  const BALL_WIDTHS = [400, 600, 900, 1200];

  /* ── Helpers ─────────────────────────────────────────────────── */

  function activeColor() {
    return document.querySelector('input[name="bsb-color"]:checked');
  }

  function activeSize() {
    return document.querySelector('input[name="bsb-size"]:checked');
  }

  function activeCountry() {
    return document.querySelector('input[name="bsb-country"]:checked');
  }

  function activeSport() {
    return document.querySelector('input[name="bsb-sport"]:checked');
  }

  function activePlanet() {
    return document.querySelector('input[name="bsb-planet"]:checked');
  }

  function activePrint() {
    return document.querySelector('input[name="bsb-print"]:checked');
  }

  function activeLetter() {
    return document.querySelector('input[name="bsb-letter"]:checked');
  }

  function activeLineColor() {
    return document.querySelector('input[name="bsb-line-color"]:checked');
  }

  function activePump() {
    return document.querySelector('input[name="bsb-pump"]:checked');
  }

  function activeOptionInputs() {
    return Array.from(document.querySelectorAll('.bsb-pi__pill-input:checked, .bsb-pi__swatch-input:checked, .bsb-pi__flag-input:checked, .bsb-pi__size-input:checked'));
  }

  function findMatchingVariantHighVariantMode() {
    const inputs = activeOptionInputs();
    for (const input of inputs) {
      const id = input.getAttribute('data-variant-id');
      if (!id) continue;
      return {
        id: Number(id),
        price: Number(input.getAttribute('data-price')),
        compareAtPrice: Number(input.getAttribute('data-compare-at-price')) || null,
        available: input.getAttribute('data-available') !== 'false',
      };
    }
    return null;
  }

  function findMatchingVariant() {
    if (highVariantMode) return findMatchingVariantHighVariantMode();
    const color   = activeColor();
    const size    = activeSize();
    const country = activeCountry();
    const sport   = activeSport();
    const planet  = activePlanet();
    const print   = activePrint();
    const letter  = activeLetter();
    const lineColor = activeLineColor();
    const pump    = activePump();
    if (!variants.length) return null;

    return variants.find((v) => {
      if (color && colorPos) {
        if (v['option' + colorPos] !== color.value) return false;
      }
      if (country && countryPos) {
        if (v['option' + countryPos] !== country.value) return false;
      }
      if (sport && sportPos) {
        if (v['option' + sportPos] !== sport.value) return false;
      }
      if (planet && planetPos) {
        if (v['option' + planetPos] !== planet.value) return false;
      }
      if (print && printPos) {
        if (v['option' + printPos] !== print.value) return false;
      }
      if (letter && letterPos) {
        if (v['option' + letterPos] !== letter.value) return false;
      }
      if (lineColor && lineColorPos) {
        if (v['option' + lineColorPos] !== lineColor.value) return false;
      }
      if (pump && pumpPos) {
        if (v['option' + pumpPos] !== pump.value) return false;
      }
      if (size && sizePos) {
        if (v['option' + sizePos] !== size.value) return false;
      }
      for (const input of activeExtraInputs()) {
        const pos = extraPosFromInputName(input.name);
        if (pos && v['option' + pos] !== input.value) return false;
      }
      return true;
    }) || null;
  }

  function findVariantForSize(sizeValue) {
    const color   = activeColor();
    const country = activeCountry();
    const sport   = activeSport();
    const planet  = activePlanet();
    const print   = activePrint();
    const letter  = activeLetter();
    const lineColor = activeLineColor();
    const pump    = activePump();
    if (!variants.length) return null;

    return variants.find((v) => {
      if (color   && colorPos   && v['option' + colorPos]   !== color.value)   return false;
      if (country && countryPos && v['option' + countryPos] !== country.value) return false;
      if (sport   && sportPos   && v['option' + sportPos]   !== sport.value)   return false;
      if (planet  && planetPos  && v['option' + planetPos]  !== planet.value)  return false;
      if (print   && printPos   && v['option' + printPos]   !== print.value)   return false;
      if (letter  && letterPos  && v['option' + letterPos]  !== letter.value)  return false;
      if (lineColor && lineColorPos && v['option' + lineColorPos] !== lineColor.value) return false;
      if (pump    && pumpPos    && v['option' + pumpPos]    !== pump.value)    return false;
      if (sizePos && v['option' + sizePos] !== sizeValue) return false;
      for (const input of activeExtraInputs()) {
        const pos = extraPosFromInputName(input.name);
        if (pos && v['option' + pos] !== input.value) return false;
      }
      return true;
    }) || null;
  }

  function preloadVariantImage(variant) {
    if (!variant) return;
    BALL_WIDTHS.forEach((w) => {
      const url = variant['img' + w];
      if (!url) return;
      const link = document.createElement('link');
      link.rel  = 'preload';
      link.as   = 'image';
      link.href = url;
      document.head.appendChild(link);
    });
  }

  function preloadSizesForActiveColor() {
    if (!sizesFieldset) return;
    sizesFieldset.querySelectorAll('.bsb-pi__size-input').forEach((sizeInput) => {
      preloadVariantImage(findVariantForSize(sizeInput.value));
    });
  }

  function updateBallImageForVariant(variant, altText) {
    if (!variant) return;
    const newSrc = variant.img900 || variant.img600 || variant.img1200 || variant.img400;
    if (!newSrc) return;
    getBallImgs().forEach((img) => {
      if (img.getAttribute('src') === newSrc && (!altText || img.alt === altText)) return;
      img.removeAttribute('srcset');
      img.src = newSrc;
      if (altText) img.alt = altText;
    });
  }

  /* ── Legend value updates ─────────────────────────────────────── */

  function updateColorName(input) {
    const name = input.getAttribute('data-color-name');
    if (colorNameEl && name) colorNameEl.textContent = name;
  }

  function updateSizeName(input) {
    if (sizeNameEl) sizeNameEl.textContent = input.value;
  }

  function updateCountryName(input) {
    const name = input.getAttribute('data-country-name');
    if (countryNameEl && name) countryNameEl.textContent = name;
  }

  function updateSportName(input) {
    if (sportNameEl) sportNameEl.textContent = input.value;
  }

  function updatePlanetName(input) {
    if (planetNameEl) planetNameEl.textContent = input.value;
  }

  function updatePrintName(input) {
    if (printNameEl) printNameEl.textContent = input.value;
  }

  function updateLetterName(input) {
    if (letterNameEl) letterNameEl.textContent = input.value;
  }

  function updateLineColorName(input) {
    if (lineColorNameEl) lineColorNameEl.textContent = input.value;
  }

  function updatePumpName(input) {
    if (pumpNameEl) pumpNameEl.textContent = input.value;
  }

  function updateExtraOptionName(input) {
    const nameEl = document.getElementById(input.name + '-name');
    if (nameEl) nameEl.textContent = input.value;
  }

  function updateSizePrices(optionInput) {
    if (!sizesFieldset || !sizePos) return;
    const color  = colorPos  ? (optionInput.name === 'bsb-color'  ? optionInput : activeColor())  : null;
    const sport  = sportPos  ? (optionInput.name === 'bsb-sport'  ? optionInput : activeSport())  : null;
    const planet = planetPos ? (optionInput.name === 'bsb-planet' ? optionInput : activePlanet()) : null;
    const print  = printPos  ? (optionInput.name === 'bsb-print'  ? optionInput : activePrint())  : null;
    const letter = letterPos ? (optionInput.name === 'bsb-letter' ? optionInput : activeLetter()) : null;
    const lineColor = lineColorPos ? (optionInput.name === 'bsb-line-color' ? optionInput : activeLineColor()) : null;
    const pump = pumpPos ? (optionInput.name === 'bsb-pump' ? optionInput : activePump()) : null;
    const extras = activeExtraInputs();

    sizesFieldset.querySelectorAll('.bsb-pi__size-input').forEach((sizeInput) => {
      const sizeValue = sizeInput.value;
      const match = variants.find((v) => {
        if (color  && colorPos  && v['option' + colorPos]  !== color.value)  return false;
        if (sport  && sportPos  && v['option' + sportPos]  !== sport.value)  return false;
        if (planet && planetPos && v['option' + planetPos] !== planet.value) return false;
        if (print  && printPos  && v['option' + printPos]  !== print.value)  return false;
        if (letter && letterPos && v['option' + letterPos] !== letter.value) return false;
        if (lineColor && lineColorPos && v['option' + lineColorPos] !== lineColor.value) return false;
        if (pump && pumpPos && v['option' + pumpPos] !== pump.value) return false;
        for (const input of extras) {
          const pos = extraPosFromInputName(input.name);
          if (pos && v['option' + pos] !== input.value) return false;
        }
        if (v['option' + sizePos] !== sizeValue) return false;
        return true;
      });
      if (!match) return;

      const label   = sizeInput.nextElementSibling;
      const priceEl = label && label.querySelector('.bsb-pi__size-price');
      // TRADE PRICING (draft): derive retail for B2B buyers when there is no compare-at.
      const tradeCompare = window.bsbTrade && window.bsbTrade.pct ? window.bsbTrade.compare(match.price, match.compareAtPrice) : match.compareAtPrice;
      if (priceEl) {
        const onSale = tradeCompare > match.price;
        priceEl.classList.toggle('bsb-pi__size-price--sale', onSale);
        priceEl.innerHTML =
          `<span class="bsb-pi__size-price-compare">${formatPrice(onSale ? tradeCompare : match.price)}</span>` +
          `<span class="bsb-pi__size-price-current">${formatPrice(match.price)}</span>`;
      }
      sizeInput.setAttribute('data-price', match.price);
      sizeInput.setAttribute('data-compare-at-price', tradeCompare);
    });
  }

  function updatePricePanel(variant) {
    if (!pricePanelEl || !variant || !window.bsbPrice) return;
    window.bsbPrice.render(pricePanelEl, variant.price, variant.compareAtPrice);
  }

  function updateInstallments(variant) {
    if (!variant) return;
    document.querySelectorAll('.bsb-pi__installments input[name="id"]').forEach((input) => {
      if (input.value === String(variant.id)) return;
      input.value = variant.id;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
  }

  function updateWishlist(variant) {
    if (!variant) return;
    document.querySelectorAll('.bsb-pi__wishlist').forEach((wrapper) => {
      wrapper.setAttribute('data-variant-id', variant.id);
      const button = wrapper.querySelector('joy-wishlist-button');
      if (button) button.setAttribute('variant-id', variant.id);
    });
  }

  const WISHLIST_BUTTON_CSS = `
    :host { display: block; width: 56px; height: 100%; }
    :host .Joy-Wishlist__Button.Joy-Wishlist__Button {
      box-sizing: border-box !important;
      flex: none !important;
      width: 56px !important;
      max-width: 56px !important;
      height: 100% !important;
      min-width: 56px !important;
      min-height: 0 !important;
      margin: 0 !important;
      padding: 0 !important;
      display: flex !important;
      align-items: center !important;
      justify-content: center !important;
      background: transparent !important;
      border: 2.5px solid #111 !important;
      border-radius: 16px !important;
      cursor: pointer;
    }
    .Joy-Wishlist__Button:hover { opacity: 0.6; }
    .Joy-Wishlist__Button:focus-visible { outline: 2px solid #111; outline-offset: 2px; }
    .Joy-Wishlist-WishlistButton__Text { display: none !important; }
    .Joy-Wishlist-WishlistButton__Icon { margin: 0 !important; color: #111 !important; }
    .Joy-Wishlist-WishlistButton__Icon path { stroke: #111 !important; stroke-width: 2.6 !important; }
    .Joy-Wishlist-WishlistButton__Icon path:not([fill="none"]) { fill: var(--bsb-accent-promo) !important; }
    .Joy-Wishlist__Button, .Joy-Wishlist__Button * { animation: none !important; transition: none !important; transform: none !important; }
  `;

  function styleWishlistButtons() {
    const buttons = document.querySelectorAll('.bsb-pi__wishlist joy-wishlist-button');
    if (!buttons.length || !window.customElements || !('adoptedStyleSheets' in Document.prototype)) return;
    customElements.whenDefined('joy-wishlist-button').then(() => {
      const sheet = new CSSStyleSheet();
      sheet.replaceSync(WISHLIST_BUTTON_CSS);
      buttons.forEach((button) => {
        Promise.resolve(button.updateComplete).then(() => {
          if (button.shadowRoot) button.shadowRoot.adoptedStyleSheets = [...button.shadowRoot.adoptedStyleSheets, sheet];
        });
      });
    });
  }

  /* ── Size tooltip ─────────────────────────────────────────────── */

  function updateSizeTooltip(input) {
    if (!tipEl) return;

    const height = input.getAttribute('data-tooltip-height');
    const best   = input.getAttribute('data-tooltip-best-for');

    if (height || best) {
      if (tipTitleEl) tipTitleEl.textContent = height || '';
      if (tipBestEl)  tipBestEl.textContent  = best || '';
      tipEl.classList.add('is-visible');
    } else {
      tipEl.classList.remove('is-visible');
    }
  }

  /* ── URL sync ─────────────────────────────────────────────────── */

  function updateVariantUrl() {
    const v = findMatchingVariant();
    if (!v) return;
    const url = new URL(window.location.href);
    url.searchParams.set('variant', v.id);
    window.history.replaceState({}, '', url);
  }

  /* Mirrors Liquid's money_without_trailing_zeros. */
  function formatPrice(cents) {
    const amount = cents / 100;
    const hasFraction = amount % 1 !== 0;
    return '$' + amount.toLocaleString(undefined, {
      minimumFractionDigits: hasFraction ? 2 : 0,
      maximumFractionDigits: 2,
    });
  }

  /* ── Upsell add-ons (pump + any generic upsell blocks) ──────────────────
     Adds straight to the cart via its own /cart/add.js call — independent
     of the bundle builder, so it can't get swallowed by (or swallow) the
     main Add to cart button's staged bundle. ── */

  document.querySelectorAll('.bsb-pi__pump-btn').forEach(function (btn) {
    btn.addEventListener('click', function () {
      const variantId = parseInt(btn.getAttribute('data-variant-id'), 10);
      if (!variantId) return;

      const original = btn.textContent.trim();
      btn.disabled = true;
      btn.textContent = 'Adding…';

      const cartAddUrl = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root)
        ? window.Shopify.routes.root + 'cart/add.js'
        : '/cart/add.js';

      const body = { items: [{ id: variantId, quantity: 1 }] };

      fetch(cartAddUrl, {
        method: 'POST',
        headers: {
          'X-Requested-With': 'XMLHttpRequest',
          'Content-Type': 'application/json',
          'Accept': 'application/json',
        },
        body: JSON.stringify(body),
      })
        .then((res) => res.json().then((d) => ({ ok: res.ok, d })))
        .then(({ ok, d }) => {
          if (!ok) throw new Error((d && d.description) || 'Cart add failed');
          btn.textContent = '✓ Added';

          const cartUrl = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root)
            ? window.Shopify.routes.root + 'cart.js'
            : '/cart.js';
          fetch(cartUrl).then((r) => r.json()).then((cart) => {
            document.dispatchEvent(new CustomEvent('cart:change', { detail: { cart } }));
          }).catch(() => {});

          setTimeout(function () {
            btn.disabled = false;
            btn.textContent = original;
          }, 1500);
        })
        .catch(function (err) {
          console.warn('[bsb-pi] Upsell add failed:', err);
          btn.textContent = 'Try again';
          setTimeout(function () {
            btn.disabled = false;
            btn.textContent = original;
          }, 1800);
        });
    });
  });

  /* ── Event handlers ───────────────────────────────────────────── */

  function onColorChange(event) {
    const input = event.target;
    if (!input || input.name !== 'bsb-color') return;
    updateColorName(input);
    updateSizePrices(input);
    updateVariantUrl();
    const colorName = input.getAttribute('data-color-name') || input.value;
    updateBallImageForVariant(findMatchingVariant(), colorName ? `${productTitle} — ${colorName}` : productTitle);
    preloadSizesForActiveColor();
    if (typeof window.bsbLgSyncColor === 'function') {
      window.bsbLgSyncColor(input.value);
    }
  }

  function onSizeChange(event) {
    const input = event.target;
    if (!input || input.name !== 'bsb-size') return;
    updateSizeName(input);
    updateSizeTooltip(input);
    updateVariantUrl();
    updateBallImageForVariant(findMatchingVariant());
  }

  function onCountryChange(event) {
    const input = event.target;
    if (!input || input.name !== 'bsb-country') return;
    updateCountryName(input);
    updateVariantUrl();

    const countryName = input.getAttribute('data-country-name') || input.value;
    updateBallImageForVariant(findMatchingVariant(), countryName ? `${productTitle} — ${countryName}` : productTitle);
  }

  function onSportChange(event) {
    const input = event.target;
    if (!input || input.name !== 'bsb-sport') return;
    updateSportName(input);
    updateSizePrices(input);
    updateVariantUrl();

    updateBallImageForVariant(findMatchingVariant(), input.value ? `${productTitle} — ${input.value}` : productTitle);
  }

  function onPlanetChange(event) {
    const input = event.target;
    if (!input || input.name !== 'bsb-planet') return;
    updatePlanetName(input);
    updateSizePrices(input);
    updateVariantUrl();

    updateBallImageForVariant(findMatchingVariant(), input.value ? `${productTitle} — ${input.value}` : productTitle);
  }

  function onPrintChange(event) {
    const input = event.target;
    if (!input || input.name !== 'bsb-print') return;
    updatePrintName(input);
    updateSizePrices(input);
    updateVariantUrl();

    updateBallImageForVariant(findMatchingVariant(), input.value ? `${productTitle} — ${input.value}` : productTitle);
  }

  function onLetterChange(event) {
    const input = event.target;
    if (!input || input.name !== 'bsb-letter') return;
    updateLetterName(input);
    updateSizePrices(input);
    updateVariantUrl();

    updateBallImageForVariant(findMatchingVariant(), input.value ? `${productTitle} — ${input.value}` : productTitle);
  }

  function onLineColorChange(event) {
    const input = event.target;
    if (!input || input.name !== 'bsb-line-color') return;
    updateLineColorName(input);
    updateSizePrices(input);
    updateVariantUrl();

    updateBallImageForVariant(findMatchingVariant(), input.value ? `${productTitle} — ${input.value}` : productTitle);
  }

  function onPumpChange(event) {
    const input = event.target;
    if (!input || input.name !== 'bsb-pump') return;
    updatePumpName(input);
    updateSizePrices(input);
    updateVariantUrl();

    updateBallImageForVariant(findMatchingVariant(), input.value ? `${productTitle} — ${input.value}` : productTitle);
  }

  function onExtraOptionChange(event) {
    const input = event.target;
    if (!input || input.name.indexOf('bsb-opt-') !== 0) return;
    updateExtraOptionName(input);
    updateSizePrices(input);
    updateVariantUrl();

    updateBallImageForVariant(findMatchingVariant(), input.value ? `${productTitle} — ${input.value}` : productTitle);
  }

  function syncBallWrapImages(freshWrap, liveWrap) {
    if (!freshWrap || !liveWrap) return;
    const freshSlides = Array.from(freshWrap.querySelectorAll('.bsb-pi__ball-slide'));
    const liveSlides = Array.from(liveWrap.querySelectorAll('.bsb-pi__ball-slide'));
    if (freshSlides.length !== liveSlides.length) {
      liveWrap.innerHTML = freshWrap.innerHTML;
      return;
    }
    freshSlides.forEach((freshSlide, i) => {
      const liveSlide = liveSlides[i];
      const freshImg = freshSlide.querySelector('.bsb-pi__ball-img');
      const liveImg = liveSlide.querySelector('.bsb-pi__ball-img');
      if (freshImg && liveImg) {
        if (liveImg.src !== freshImg.src) liveImg.src = freshImg.src;
        if (liveImg.srcset !== freshImg.srcset) liveImg.srcset = freshImg.srcset;
      } else if (freshSlide.innerHTML !== liveSlide.innerHTML) {
        liveSlide.innerHTML = freshSlide.innerHTML;
      }
    });
  }

  function refetchConfigurator() {
    if (!highVariantMode || !sectionId || !configEl) return;
    const optionValueIds = activeOptionInputs()
      .map((input) => input.getAttribute('data-option-value-id'))
      .filter(Boolean);
    if (!optionValueIds.length) return;

    configEl.classList.add('bsb-pi__config--loading');
    const url = `${window.location.pathname}?section_id=${sectionId}&option_values=${optionValueIds.join(',')}`;

    fetch(url)
      .then((res) => res.text())
      .then((html) => {
        const doc = new DOMParser().parseFromString(html, 'text/html');
        const fresh = doc.getElementById('bsb-configurator');
        if (fresh) {
          configEl.innerHTML = fresh.innerHTML;
          requeryConfiguratorRefs();
        }
        syncBallWrapImages(doc.getElementById('bsb-ball-wrap'), document.getElementById('bsb-ball-wrap'));
        updatePricePanel(findMatchingVariant());
        document.dispatchEvent(new CustomEvent('bsb:configurator-refreshed'));
      })
      .catch(() => {})
      .finally(() => {
        configEl.classList.remove('bsb-pi__config--loading');
      });
  }

  document.addEventListener('change', function (e) {
    if (e.target.closest('.bsb-pi__installments')) return;
    if (e.target.name === 'bsb-color')   onColorChange(e);
    if (e.target.name === 'bsb-size')    onSizeChange(e);
    if (e.target.name === 'bsb-country') onCountryChange(e);
    if (e.target.name === 'bsb-sport')   onSportChange(e);
    if (e.target.name === 'bsb-planet')  onPlanetChange(e);
    if (e.target.name === 'bsb-print')   onPrintChange(e);
    if (e.target.name === 'bsb-letter')  onLetterChange(e);
    if (e.target.name === 'bsb-line-color') onLineColorChange(e);
    if (e.target.name === 'bsb-pump') onPumpChange(e);
    if (e.target.name.indexOf('bsb-opt-') === 0) onExtraOptionChange(e);
    const matchedVariant = findMatchingVariant();
    updatePricePanel(matchedVariant);
    updateInstallments(matchedVariant);
    updateWishlist(matchedVariant);
    document.dispatchEvent(new CustomEvent('bsb:variant-change', { detail: { variant: matchedVariant } }));
    if (!highVariantMode) syncCarouselSlides();
    syncAvailability();
    refetchConfigurator();
  });

  document.querySelectorAll('label[for^="bsb-color-"]').forEach((label) => {
    label.addEventListener('pointerenter', function () {
      const input = document.getElementById(label.htmlFor);
      if (!input || input.dataset.ballImgPreloaded) return;
      input.dataset.ballImgPreloaded = '1';
      BALL_WIDTHS.forEach((w) => {
        const url = input.getAttribute('data-ball-image-' + w);
        if (!url) return;
        const link = document.createElement('link');
        link.rel  = 'preload';
        link.as   = 'image';
        link.href = url;
        document.head.appendChild(link);
      });
    }, { passive: true });
  });

  document.querySelectorAll('label[for^="bsb-size-"]').forEach((label) => {
    label.addEventListener('pointerenter', function () {
      const input = document.getElementById(label.htmlFor);
      if (!input || input.dataset.ballImgPreloaded) return;
      input.dataset.ballImgPreloaded = '1';
      preloadVariantImage(findVariantForSize(input.value));
    }, { passive: true });
  });

  /* Tooltip for the pre-selected size. */
  const initialSize = activeSize();
  if (initialSize) updateSizeTooltip(initialSize);

  preloadSizesForActiveColor();
  if (!highVariantMode) syncCarouselSlides();
  syncAvailability();


  /* Delivery date = today + delivery_days. */

  if (delDateEl) {
    const days = parseInt(delDateEl.getAttribute('data-delivery-days'), 10);
    if (!Number.isNaN(days)) {
      const d = new Date();
      d.setDate(d.getDate() + days);
      delDateEl.textContent = d.toLocaleDateString(undefined, { month: 'short', day: 'numeric' });
    }
  }

  styleWishlistButtons();

  window.bsbGetCurrentVariantId  = () => { const v = findMatchingVariant(); return v ? v.id : null; };
  window.bsbGetCurrentVariant    = () => findMatchingVariant();
  window.bsbUpdateSizePrices     = updateSizePrices;
})();
